import { createAction } from '@reduxjs/toolkit'
import isNull from 'lodash/isNull'
import { call, takeLatest } from 'redux-saga/effects'

import managers from '../../lib/managers'
import { PaperManager } from '../../lib/managers/PaperManager'
import { Zoom } from '../../lib/toolBoxes/2D/tools'

export const resize2DCanvas = createAction('2D/resizeCanvas')

export function* handleResize2DCanvas() {
    const manager: PaperManager | null = yield call(managers.get2DManager)

    if (isNull(manager)) return

    const zoomTool: Zoom = manager.getTool(Zoom.NAME)
    const paper = zoomTool.getPaperScope()
    const canvas = paper.view.element as HTMLCanvasElement
    const bounds = canvas.getBoundingClientRect()

    // Update the Paper.js view size to match the new canvas dimensions
    paper.view.viewSize = new paper.Size(bounds.width, bounds.height)

    // Update the zoom tool's bounding box coordinates
    zoomTool.updateClientBounds(bounds)
}

export function* watchFor2DCanvasResize() {
    yield takeLatest(resize2DCanvas.type, handleResize2DCanvas)
}
